import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage, FormattedHTMLMessage, useIntl } from "react-intl";
import cn from "classnames";
import { useLocation } from "react-router";

import { reg_email } from "../../../common/parameters";
import Seo from "../../../common/helpers/seo";
import { post } from "../../actions/general";

import Form, { InputText, InputPassword, Submit } from "../../components/Form";

import { StyledPasswordRecovery, FormWrapper, SuccessScreen } from "./styles";
import messages from "./messages";
import { Link } from "react-router-dom";
import routing from "../../routing";

const PasswordRecovery = () => {
    const dispatch = useDispatch();
    const { formatMessage } = useIntl();
    const { search } = useLocation();
    let _id = search.slice(5);
    const [form1, setForm1] = useState<{ email: string, success1: boolean, validationEmail: string | undefined}>({
        email: "",
        success1: false,
        validationEmail: undefined,
    });
    const [form2, setForm2] = useState<{ password: string, password2: string, success2: boolean, key: string, validationPassword: string | undefined, validationPassword2: string | undefined }>({
        password: "",
        password2: "",
        success2: false,
        key: _id,
        validationPassword: undefined,
        validationPassword2: undefined,
    });
    const [loading, setLoading] = useState(false);

    const changeEmail = (e: React.FormEvent<HTMLInputElement>) => {
        setForm1({
            ...form1,
            email: e.currentTarget.value,
            validationEmail: undefined
        })
    };
    const changePassword = (e: React.FormEvent<HTMLInputElement>) => {
        setForm2({
            ...form2,
            password: e.currentTarget.value,
            validationPassword: undefined,
        });
    };
    const changePassword2 = (e: React.FormEvent<HTMLInputElement>) => {
        setForm2({
            ...form2,
            password2: e.currentTarget.value,
            validationPassword2: undefined,
        });
    };
    
    const sendEmail = () => {
        if (!form1.email) {
            setForm1(form => ({
                ...form,
                validationEmail: "required",
            }))
            return;
        }
        if (!reg_email.test(form1.email)) {
            setForm1(form => ({
                ...form,
                validationEmail: "incorrectEmailFormat",
            }));
            return;
        }
        setLoading(true);
        dispatch(post(
            "password-recovery-email",
            {
                email: form1.email,
            },
            res => {
                const { data } = res;
                if (data.success) {
                    setForm1(form => ({
                        ...form,
                        success1: true,
                    }))
                } else if (data === "emailNotFound") {
                    setForm1(form => ({
                        ...form,
                        validationEmail: "emailNotFound",
                    }))
                }
                setLoading(false);
            }
        ));
    };
    const sendPassword = () => {
        if (form2.password.length === 0) {
            setForm2(form => ({
                ...form,
                validationPassword: "required",
            }))
        }
        if (form2.password2.length === 0) {
            setForm2(form => ({
                ...form,
                validationPassword2: "required"
            }))
        }
        if (form2.password2.length === 0 || form2.password.length === 0) return;
        if (form2.password.length < 8) {
            setForm2(form => ({
                ...form,
                validationPassword: "passwordTooShort"
            }));
            return
        }
        if (form2.password !== form2.password2) {
            setForm2(form => ({
                ...form,
                validationPassword: "passwordDoNotMatch",
                validationPassword2: "1"
            }));
            return;
        }
        setLoading(true);
        dispatch(post("password-recovery-password", { password: form2.password, key: form2.key }, res => {
            const { data } = res;
            if (data.success) {
                setForm2(form => ({
                    ...form,
                    success2: true,
                }));
            } else if (data === "invalidKey") {
                setForm2(form => ({
                    ...form,
                    validationPassword: "unknownError",
                }));
            } else {
                setForm2(form => ({
                    ...form,
                    validationPassword: "unknownError"
                }));
            }
            setLoading(false);
        }));
    };
   
    return (
        <StyledPasswordRecovery
            marginTop={50}
            className={cn("spring--shadow", "spring--padding", (form1.success1 || form2.success2) && "Flex")}
        >
            <Seo title={formatMessage(messages.title)} />
            <FormWrapper>
                {form2.key ? (
                    (form1.success1 || form2.success2) ? (
                        <SuccessScreen>
                            <p>
                                <FormattedHTMLMessage {...messages.success} />
                            </p>
                            <Link to={routing.login}>
                                <button
                                    className="button"
                                >
                                    <FormattedMessage {...messages.login} />
                                </button>
                            </Link>
                        </SuccessScreen>
                    ) : (
                        <Form disabled={loading}>
                            <h2>
                                <FormattedMessage {...messages.titleSet} />
                            </h2>
                            <InputPassword
                                required
                                validation={form2.validationPassword}
                                label={formatMessage(messages.password)}
                                value={form2.password}
                                onChange={changePassword}
                            />
                            <InputPassword
                                required
                                validation={form2.validationPassword2}
                                label={formatMessage(messages.passwordAgain)}
                                value={form2.password2}
                                onChange={changePassword2}
                            />
                            <Submit onClick={sendPassword} loading={loading}>
                                <FormattedMessage {...messages.submit} />
                            </Submit>
                        </Form>
                    )
                ) : (form1.success1 || form2.success2) ? (
                    <SuccessScreen>
                        <p>
                            <FormattedMessage {...messages.recoverySent} />
                        </p>
                        <p>
                            <FormattedMessage {...messages.checkEmail} />
                        </p>
                    </SuccessScreen>
                ) : (
                    <Form disabled={loading}>
                        <h2>
                            <FormattedMessage {...messages.title} />
                        </h2>
                        <InputText
                            required
                            email
                            validation={form1.validationEmail}
                            label={formatMessage(messages.email)}
                            value={form1.email}
                            onChange={changeEmail}
                            name="email"
                        />
                        <Submit onClick={sendEmail} loading={loading}>
                            <FormattedMessage {...messages.submit} />
                        </Submit>
                    </Form>
                )}
            </FormWrapper>
        </StyledPasswordRecovery>
    );
};

export default PasswordRecovery;
